import React from 'react';
import { StyleSheet, View } from 'react-native';
import { rem } from 'design-system';
import Text from 'design-system/Text';
import { TransUnionHeader } from 'features/rent-reporting/svg/TransUnionHeader';
import useColors from 'hooks/useColors';
const CreditReportFooter = React.memo(() => {
    const colors = useColors();
    return (<View style={styles.footerContainer}>
      <View style={styles.footerContent}>
        <Text TextThin-14 Gray>
          {'Data from'}
        </Text>
        <View style={styles.logoContainer}>
          <TransUnionHeader width={99} height={26} color={colors.text.secondary}/>
        </View>
      </View>
    </View>);
});
export default CreditReportFooter;
const styles = StyleSheet.create({
    footerContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        paddingVertical: rem(32),
        paddingHorizontal: rem(16),
    },
    footerContent: {
        flexDirection: 'row',
        gap: rem(4),
        alignItems: 'flex-end',
    },
    logoContainer: {
        paddingBottom: rem(1),
    },
});
